import { takeLatest } from "redux-saga/effects";

import { INVITES } from "../actions/actionConstants.js";

import { getEntitySaga, createEntitySaga } from "./apiSagas.js";

// -- ROOT WATCHERS -- //

export function* watchInviteSagas() {
  yield takeLatest(INVITES.GET, getEntitySaga, INVITES, undefined);
  yield takeLatest(INVITES.POST, createEntitySaga, INVITES, undefined);
}
